// frontend/src/config/apiPaths.js
export const API = {
  group: {
    verify: '/api/group/verify',
    info: { get: '/api/group/info', put: '/api/group/info' },
    state: '/api/group/state',
  },
  invitations: {
    list: () => '/api/invitation',
    create: () => '/api/invitation',
    status: (hash) => `/api/invitation/${hash}/status`,
    contact: (hash) => `/api/invitation/${hash}/contact`,
    delete: (hash) => `/api/invitation/${hash}`,
    resend: (hash) => `/api/invitation/${hash}/send-email`,
  },
};
